import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export function useFetch(url, interval = 0, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    if (!url) return;
    try { const r = await api.get(url); setData(r.data); setError(null); }
    catch (e) { setError(e); }
    finally { setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);
  useEffect(() => {
    load();
    if (!interval) return;
    const id = setInterval(load, interval);
    return () => clearInterval(id);
  }, [load, interval]);
  return { data, error, loading, reload: load, setData };
}
